import { supabase } from '@/lib/supabase';
import type { AddonCatalogItem, AddAddonParams, OrgAddon } from '@/types';

export const addonsApi = {
  listCatalog: async (includeInactive = false): Promise<AddonCatalogItem[]> => {
    let q = supabase.from('addon_catalog').select('*').order('sort_order');
    if (!includeInactive) q = q.eq('is_active', true);
    const { data, error } = await q;
    if (error) throw error;
    return data as AddonCatalogItem[];
  },

  createCatalogItem: async (item: Omit<AddonCatalogItem, 'created_at'>): Promise<AddonCatalogItem> => {
    const { data, error } = await supabase
      .from('addon_catalog')
      .insert(item)
      .select()
      .single();
    if (error) throw error;
    return data as AddonCatalogItem;
  },

  updateCatalogItem: async (code: string, patch: Partial<AddonCatalogItem>): Promise<AddonCatalogItem> => {
    const { data, error } = await supabase
      .from('addon_catalog')
      .update(patch)
      .eq('code', code)
      .select()
      .single();
    if (error) throw error;
    return data as AddonCatalogItem;
  },

  deleteCatalogItem: async (code: string): Promise<void> => {
    const { error } = await supabase
      .from('addon_catalog')
      .delete()
      .eq('code', code);
    if (error) throw error;
  },

  listForOrg: async (orgId: string): Promise<OrgAddon[]> => {
    const { data, error } = await supabase
      .from('org_addons')
      .select('*, addon_catalog(*)')
      .eq('org_id', orgId)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data as OrgAddon[];
  },

  addForOrg: async (orgId: string, params: AddAddonParams): Promise<OrgAddon> => {
    const { data, error } = await supabase.rpc('add_org_addon', {
      p_org_id: orgId,
      p_addon_code: params.addonCode,
      p_qty: params.quantity,
      p_cycle: params.billingCycle,
      p_approver_name: params.approverName,
      p_approver_role: params.approverRole,
      p_signature: params.signature,
    });
    if (error) throw error;
    return data as OrgAddon;
  },

  cancel: async (id: string): Promise<OrgAddon> => {
    const { data, error } = await supabase
      .from('org_addons')
      .update({
        status: 'cancelled',
        expires_at: new Date().toISOString(),
      })
      .eq('id', id)
      .select('*, addon_catalog(*)')
      .single();
    if (error) throw error;
    return data as OrgAddon;
  },
};
